import React from 'react'
import {Breadcrumb, Placeholder, Table} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {default as Lotteryrow} from './lotteryrow.js'

export default function Lotterylist() {
    const firestore = useFirestore()

    useFirestoreConnect([
        { collection: 'environments/dev/lotteries', orderBy: ['state'] }
    ])
    const states = useSelector(state => state.firestore.ordered['environments/dev/lotteries'])

    useFirestoreConnect([
        { collection: 'environments/dev/store-locator' }
    ])
    const storelocator = useSelector(state => state.firestore.ordered['environments/dev/store-locator'])


    if(typeof states === 'undefined')
        return (
            <div>
                <Placeholder>
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                    <Placeholder.Line />
                </Placeholder>
            </div>
        )

    const storelocatorByState = {};

    if(typeof storelocator !== 'undefined')
        for(var state of storelocator)
            storelocatorByState[state.id] = state;

  return (
    <div>
        <div style={{
            marginTop: '-60px',
            paddingTop: '20px',
            height: '60px',
            position: 'fixed',
            width: '100%',
            backgroundColor: '#FFFFFF'
        }}>
            <Breadcrumb style={{
                paddingLeft: '20px',
                marginLeft: '20px',
            }}>
                <Breadcrumb.Section>Store-Locator</Breadcrumb.Section>
            </Breadcrumb>
        </div>
        <div style={{
            marginTop: '60px'
        }}>
            <Table padded>
                <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Bundesland</Table.HeaderCell>
                    <Table.HeaderCell>Letzter Import</Table.HeaderCell>
                    <Table.HeaderCell style={{
                                        textAlign: 'center'
                                    }}>gültig</Table.HeaderCell>
                    <Table.HeaderCell style={{
                                        textAlign: 'center'
                                    }}>ohne Geo</Table.HeaderCell>
                    <Table.HeaderCell style={{
                                        textAlign: 'center'
                                    }}>Formatfehler</Table.HeaderCell>
                    <Table.HeaderCell style={{
                                        textAlign: 'center'
                                    }}>gesperrt</Table.HeaderCell>
                    <Table.HeaderCell>Upload</Table.HeaderCell>
                </Table.Row>
            
                </Table.Header>

                <Table.Body>
                    {            
                        Object.keys(states).map(
                            (key, id) => (
                                <Lotteryrow key={key} state={states[key]} storelocatorDetails={(typeof storelocatorByState[states[key].id] !== 'undefined')?storelocatorByState[states[key].id]:null}/>
                            )
                        )
                    }
                </Table.Body>
            </Table>
        </div>
  </div>
  )
}